import { createFileRoute } from '@tanstack/react-router';
import { EntitiesListPage } from '../features/entities/EntitiesListPage';

export const Route = createFileRoute('/entities/')({
  component: EntitiesListPage,
});
